"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useList = void 0;

var React = __importStar(require("react"));

var utils_1 = require("./utils");

var use_update_1 = require("./use-update");

function useList(initialList) {
  if (initialList === void 0) {
    initialList = [];
  }

  var list = React.useRef(utils_1.resolveHookState(initialList));
  var update = use_update_1.useUpdate();
  var methods = React.useMemo(function () {
    var mthds = {
      set: function set(newList) {
        list.current = utils_1.resolveHookState(newList, list.current);
        update();
      },
      push: function push() {
        var items = [];

        for (var _i = 0; _i < arguments.length; _i++) {
          items[_i] = arguments[_i];
        }

        if (items.length) {
          mthds.set(function (curr) {
            return curr.concat(items);
          });
        }
      },
      updateAt: function updateAt(index, item) {
        mthds.set(function (curr) {
          var arr = curr.slice();
          arr[index] = item;
          return arr;
        });
      },
      insertAt: function insertAt(index, item) {
        mthds.set(function (curr) {
          var arr = curr.slice();
          index > arr.length ? arr[index] = item : arr.splice(index, 0, item);
          return arr;
        });
      },
      update: function update(predicate, newItem) {
        mthds.set(function (curr) {
          return curr.map(function (item) {
            return predicate(item, newItem) ? newItem : item;
          });
        });
      },
      updateFirst: function updateFirst(predicate, newItem) {
        var index = list.current.findIndex(function (item) {
          return predicate(item, newItem);
        });
        index >= 0 && mthds.updateAt(index, newItem);
      },
      upsert: function upsert(predicate, newItem) {
        var index = list.current.findIndex(function (item) {
          return predicate(item, newItem);
        });
        index >= 0 ? mthds.updateAt(index, newItem) : mthds.push(newItem);
      },
      sort: function sort(compareFn) {
        mthds.set(function (curr) {
          return curr.slice().sort(compareFn);
        });
      },
      filter: function filter(callbackFn, thisArg) {
        mthds.set(function (curr) {
          return curr.slice().filter(callbackFn, thisArg);
        });
      },
      removeAt: function removeAt(index) {
        mthds.set(function (curr) {
          var arr = curr.slice();
          arr.splice(index, 1);
          return arr;
        });
      },
      clear: function clear() {
        mthds.set([]);
      },
      reset: function reset() {
        mthds.set(utils_1.resolveHookState(initialList).slice());
      }
    };
    return mthds;
  }, []);
  return [list.current, methods];
}

exports.useList = useList;